import STATE from './state';

import { createStore } from '@harlem/core';

const NAME = 'app';

export const { state, getter, mutation } = createStore(NAME, STATE);
